<div id="lista" class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div
            class="header accent"
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center"
        >
            <!-- TITLE AND ACTION BUTTONS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- APP TITLE -->
                <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16" style="color: #fff"> business </mat-icon>
                    <span class="logo-text h1" style="color: #fff">
                        {{ titulo }}
                    </span>
                </div>
                <!-- / APP TITLE -->

                <!-- ACTION BUTTONS -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px">
                    <!-- Consult Button -->
                    <button mat-mini-fab color="accent" matTooltip="Consultar Boleta" (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>

                    <!-- Export Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Exportar Boleta"
                        (click)="getAllExport()"
                        *ngIf="_authService.isPermissao(['Exportar Boleta'])"
                    >
                        <mat-icon>cloud_download</mat-icon>
                    </button>

                    <!-- Add Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Adicionar Boleta"
                        (click)="openCadastro()"
                        *ngIf="_authService.isPermissao(['Cadastrar Boleta'])"
                    >
                        <mat-icon>add_circle</mat-icon>
                    </button>

                    <!-- Delete All Button -->
                    <button
                        mat-mini-fab
                        color="warn"
                        matTooltip="Excluir Boletas"
                        (click)="deleteAll()"
                        *ngIf="_authService.isPermissao(['Excluir Boleta'])"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>

                    <!-- Update Status Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Atualizar Status"
                        (click)="openAtualizar()"
                        *ngIf="_authService.isPermissao(['Atualiza Status Boleta'])"
                    >
                        <mat-icon>update</mat-icon>
                    </button>

                    <!-- Clear Filter Button -->
                    <button
                        mat-mini-fab
                        class="warn"
                        matTooltip="Limpar Filtro"
                        (click)="clearFiltro()"
                        *ngIf="hasActiveFilters"
                        data-testid="botao-limpar-filtro"
                    >
                        <mat-icon>clear</mat-icon>
                    </button>

                    <!-- Block Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Bloqueiar Boletas"
                        (click)="bloqueiarBoletas('B')"
                        *ngIf="_authService.isPermissao(['Bloqueiar Boletas'])"
                    >
                        <mat-icon>lock</mat-icon>
                    </button>

                    <!-- Unblock Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Desbloquear Boletas"
                        (click)="bloqueiarBoletas('D')"
                        *ngIf="_authService.isPermissao(['Bloqueiar Boletas'])"
                    >
                        <mat-icon>lock_open</mat-icon>
                    </button>
                </div>
                <!-- / ACTION BUTTONS -->
            </div>
            <!-- / TITLE AND ACTION BUTTONS -->

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <input
                        #filter
                        placeholder="Buscar Por Nome, CPF ou Conta"
                        [formControl]="search"
                        (keyup)="onEnter(filter.value)"
                        (keyup.enter)="onEnter(filter.value)"
                    />
                    <mat-icon style="cursor: pointer" (click)="getAll()"> search </mat-icon>
                </div>
            </div>
            <!-- / SEARCH -->
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- Loading Indicator -->
            <div *ngIf="loadingIndicator" class="loading-container p-16" style="text-align: center">
                <mat-spinner diameter="30"></mat-spinner>
                <span style="margin-left: 8px" data-testid="loading-indicator">Carregando...</span>
            </div>

            <ngx-datatable
                #table
                class="material striped"
                [columns]="columns"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [selected]="selected"
                [selectionType]="SelectionType.checkbox"
                [selectAllRowsOnPage]="false"
                (select)="onSelect($event)"
                (sort)="onSort($event)"
                [rows]="rows"
                [messages]="{
                    emptyMessage: loadingIndicator ? 'Carregando boletas...' : 'Nenhuma boleta encontrada'
                }"
            >
                <ngx-datatable-column
                    [width]="30"
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [headerCheckboxable]="true"
                    [checkboxable]="true"
                >
                </ngx-datatable-column>

                <ngx-datatable-column name="Data" prop="data_operacao" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-data_operacao="value" ngx-datatable-cell-template>
                        {{ data_operacao | date : "dd/MM/yyyy H:mm" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    title="Data de Atualização"
                    name="Dt Atualização"
                    prop="updated_at"
                    [sortable]="true"
                >
                    <ng-template let-rowIndex="rowIndex" let-updated_at="value" ngx-datatable-cell-template>
                        {{ updated_at | date : "dd/MM/yyyy H:mm" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    name="Responsável"
                    matTooltip="Responsavel por realizar a operação"
                    prop="operador_id"
                    [sortable]="true"
                >
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.operador }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    name="Escritório"
                    prop="escritorio_id"
                    [sortable]="false"
                    *ngIf="this.user.role_id !== UserRole.SOCIO_ASSESSOR"
                >
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.escritorio }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <b>{{ row.numero_xp }}</b> - {{ row.nome_cliente }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Estratégia" prop="estrategia_id" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="estrategia-cell">
                            <span
                                class="estrategia-indicator {{ getEstrategiaColor(row) }}"
                                [matTooltip]="'Estratégia: ' + row.estrategia"
                            ></span>
                            <span class="estrategia-text">{{ row.estrategia }}</span>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Valor (R$)" prop="valor" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ exibeValor(row) | number : "1.2-2" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Status" prop="status" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span
                            [ngClass]="{
                                status_boleta_efetivada: row.status_id == StatusBoletaRendaVariavel.OPERACAO_EFETIVADA,
                                status_efeitivada_parcial: row.status_id == StatusBoletaRendaVariavel.BOLETA_COE,
                                status_boleta_error:
                                    row.status_id != StatusBoletaRendaVariavel.OPERACAO_EFETIVADA &&
                                    row.status_id != StatusBoletaRendaVariavel.BOLETA_MRV &&
                                    row.status_id != StatusBoletaRendaVariavel.PRIMEIRA_OPERACAO &&
                                    row.status_id != StatusBoletaRendaVariavel.ENVIADA
                            }"
                        >
                            {{ row.status }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="actions"
                            matTooltip="Mostrar Opções"
                            *ngIf="alterarBoleta(row)"
                        >
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <!-- / ADD BUTTON -->
                        <mat-menu #actions="matMenu">
                            <button
                                mat-menu-item
                                (click)="openCadastroBoletaExecucacao(row.id)"
                                *ngIf="
                                    user.role_id == UserRole.ADMINISTRADOR_SISTEMAS ||
                                    user.role_id == UserRole.SOCIO_OPERADOR_RENDA_VARIAVEL ||
                                    user.role_id == UserRole.SOCIO_DIRETOR_ESPECIALISTA_RENDA_VARIAVEL
                                "
                            >
                                <mat-icon>attach_money</mat-icon>
                                BOLETA EXECUÇÃO
                            </button>

                            <button mat-menu-item (click)="openAlterar(row.id)" *ngIf="alterarBoleta(row)">
                                <mat-icon aria-label="Editar">edit</mat-icon>
                                EDITAR BOLETA
                            </button>

                            <button mat-menu-item color="warn" (click)="delete(row)" *ngIf="alterarBoleta(row)">
                                <mat-icon aria-label="Excluir Boleta">delete</mat-icon>
                                EXCLUIR BOLETA
                            </button>
                        </mat-menu>

                        <mat-icon
                            aria-label="Boletas Bloqueadas"
                            color="warn"
                            matTooltip="Boleta Bloqueadas"
                            *ngIf="!alterarBoleta(row)"
                        >
                            lock
                        </mat-icon>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator
                    #paginator
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)"
                >
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
